import ProductCardContextProvider, { useProductCardContext } from '../../context/ProductCardContext';
import { UPSELL_TYPES } from '../../utils/constants';
import SmallCardHeader from '../small-card-layout/header/SmallCardHeader';
import ProductUpSell from '../ProductUpSell';
import { viSmallCardHeaderGrid } from './styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const ViSmallCardHeader = ({
  className
}) => {
  const context = useProductCardContext();
  const {
    extraProps,
    upSell,
    shouldDisplayUpsell
  } = context;
  const viPromotionalPill = extraProps === null || extraProps === void 0 ? void 0 : extraProps.viPromotionalPill;
  const shouldDisplayContextUpsell = shouldDisplayUpsell && (upSell === null || upSell === void 0 ? void 0 : upSell.content);
  const upsellChildren = shouldDisplayContextUpsell || viPromotionalPill ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [shouldDisplayContextUpsell && /*#__PURE__*/_jsx(ProductUpSell, {
      upSell: upSell
    }), viPromotionalPill && /*#__PURE__*/_jsx(ProductUpSell, {
      upSell: {
        content: viPromotionalPill,
        type: UPSELL_TYPES.PROMOTIONAL
      }
    })]
  }) : undefined;
  return /*#__PURE__*/_jsx(ProductCardContextProvider, {
    productData: {
      ...context,
      shouldDisplayUpsell: false
    },
    children: /*#__PURE__*/_jsx(SmallCardHeader, {
      className: className,
      customGrid: viSmallCardHeaderGrid,
      children: upsellChildren
    })
  });
};
export default ViSmallCardHeader;
//# sourceMappingURL=ViSmallCardHeader.js.map